import { EmployeeLinkFieldWithNameLoading } from 'domain/shared/employee';
import { BadgeField, FieldProps } from 'framework/ui/field';
import { Badge } from 'framework/ui/mui-builder';
import { MappedTeamMember } from 'domain/shared/newProject';
import TeamMemberContractBadges from './TeamMemberContractBadges';

const TeamMemberField = ({ source, ...props }: FieldProps) => {
  return (
    <BadgeField
      style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '4px' }}
      source={source}
      badges={[
        <TeamMemberContractBadges source={source} />,
        <Badge color="default" isVisible={(data: MappedTeamMember) => data.isBackup} sx={{ ml: 0 }}>
          Backup
        </Badge>,
        <Badge color="default" isVisible={(data: MappedTeamMember) => data.isProbation} sx={{ ml: 0 }}>
          Probation
        </Badge>,
        <Badge color="default" isVisible={(data: MappedTeamMember) => data.isBench} sx={{ ml: 0 }}>
          Bench
        </Badge>,
      ]}
    >
      <EmployeeLinkFieldWithNameLoading ignoredNameParts={['middleName', 'maidenName']} source={source} {...props} />
    </BadgeField>
  );
};

export default TeamMemberField;
